export default { styleOverrides: { root: {} } };
